import { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { api, apiError } from "@/lib/api";
import { formatNumber, formatTRY } from "@/lib/format";

export const trNum = (s) => {
  if (s === "" || s == null) return null;
  const t = String(s).trim().replace(/\s/g, "");
  const n = Number(t.includes(",") ? t.replace(/\./g, "").replace(",", ".") : t);
  return Number.isFinite(n) ? n : NaN;
};
export const cbmOf = (count, cbm) => (count === "" || count == null || trNum(cbm) == null ? null : Math.round(Number(count) * trNum(cbm) * 10000) / 10000);
export const fmtCbm = (v) => (v == null ? "—" : `${formatNumber(v, 3)} m³`);

function Cell({ value, onSave, testid, width = "w-20", disabled }) {
  const [v, setV] = useState(value == null ? "" : String(value).replace(".", ","));
  const save = () => { const n = trNum(v); if (Number.isNaN(n)) { toast.error("Geçersiz sayı"); return; } if (n !== (value ?? null)) onSave(n); };
  return <Input value={v} disabled={disabled} onChange={(e) => setV(e.target.value)} onBlur={save} onKeyDown={(e) => e.key === "Enter" && e.currentTarget.blur()}
    className={`h-7 ${width} ml-auto text-right font-mono text-[12px]`} inputMode="decimal" data-testid={testid} />;
}

export function LineCostCells({ imp, l, editable, reload }) {
  const patch = async (ch) => { try { await api.patch(`/imports/${imp.id}/lines/${l.line_id}`, ch); reload(); } catch (e) { toast.error(apiError(e)); reload(); } };
  const kalem = imp.customs_mode === "kalem";
  return (<>
    <td>{editable ? <Cell value={l.carton_count} onSave={(n) => patch({ carton_count: n == null ? null : Math.round(n) })} testid={`import-line-cartons-${l.sku}`} width="w-16" /> : <span className="font-mono">{l.carton_count ?? "—"}</span>}</td>
    <td>{editable ? <Cell value={l.carton_cbm} onSave={(n) => patch({ carton_cbm: n })} testid={`import-line-carton-cbm-${l.sku}`} /> : <span className="font-mono">{l.carton_cbm == null ? "—" : formatNumber(l.carton_cbm, 4)}</span>}</td>
    <td className="text-right font-mono" data-testid={`import-line-cbm-${l.sku}`}>{fmtCbm(l.cbm_total)}{l.cbm_legacy && <div className="text-[10px] text-slate-400">eski hacim</div>}</td>
    {kalem && <td>{editable ? <div className="flex items-center gap-1 justify-end"><Cell value={l.duty_amount} onSave={(n) => patch({ duty_amount: n, duty_currency: l.duty_currency || "TRY" })} testid={`import-line-duty-${l.sku}`} width="w-24" />
      <select className="h-7 text-[11px] border rounded" value={l.duty_currency || "TRY"} onChange={(e) => patch({ duty_currency: e.target.value })} data-testid={`import-line-duty-cur-${l.sku}`}>{[...new Set(["TRY", imp.currency])].map((c) => <option key={c}>{c}</option>)}</select></div>
      : <span className="font-mono">{formatTRY(l.duty_try)}</span>}</td>}
  </>);
}
